module.exports = __webpack_public_path__ + "assets/icon-joe.44d88251.svg";